'use client'

import { useState } from 'react'
import { useSession } from '@wiggot/auth/hooks/useSession'
import { useNotificationStore } from '../store/notifications-store'
import { patchMarkAsReadNotification } from '../services'
import type { INotification } from '../../interfaces/src'

export const useNotification = () => {
  const [isLoadingMarkAsRead, setIsLoadingMarkAsRead] = useState(false)

  const handleUpdateNotification = useNotificationStore(
    (state) => state.handleUpdateNotification
  )

  const { profile } = useSession()

  const userId = profile?.userId?.toString() ?? ''

  const markAsReadNotification = async (notificationId: number) => {
    try {
      setIsLoadingMarkAsRead(true)
      const { isSuccess } = await patchMarkAsReadNotification({
        userId,
        notificationId: notificationId?.toString()
      })
      if (isSuccess) {
        handleUpdateNotification(notificationId)
      }
    } finally {
      setIsLoadingMarkAsRead(false)
    }
  }

  const handleClickInNotification = (notification: INotification) => {
    if (!notification.read) {
      markAsReadNotification(notification?.notificationId)
    }
  }

  return {
    handleClickInNotification,
    isLoadingMarkAsRead
  }
}
